import { HydratedCallRecord } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records/v1/call_record.pb';
import { callStatusUtils } from '@frontend/call-intel-core';

export const isAnalyzedCall = (record: HydratedCallRecord): boolean =>
  !!record.callIntelInsights?.id &&
  !callStatusUtils.isSkippedCall(record?.callIntelInsights.status) &&
  !callStatusUtils.isFailedCall(record?.callIntelInsights.status) &&
  record.status === 'answered';

export const hasPatientContact = (record: HydratedCallRecord): boolean =>
  !!(record.personId || record.person?.personId || record.callIntelInsights?.person?.id);

export const findBestEligibleCallIdx = (records: HydratedCallRecord[]): number => {
  let firstAnalyzedIdx = -1;
  for (let i = 0; i < records.length; i++) {
    if (!isAnalyzedCall(records[i])) continue;
    if (hasPatientContact(records[i])) return i;
    if (firstAnalyzedIdx === -1) firstAnalyzedIdx = i;
  }
  return firstAnalyzedIdx;
};

export const findBestEligibleCall = <T extends HydratedCallRecord>(records: T[]): T | undefined => {
  const idx = findBestEligibleCallIdx(records);
  return idx === -1 ? undefined : records[idx];
};

export const findBestEligibleCallWithContact = <T extends HydratedCallRecord>(records: T[]): T | undefined =>
  records.find((record) => isAnalyzedCall(record) && hasPatientContact(record));
